import { render, staticRenderFns } from "./orderGiftList.vue?vue&type=template&id=971adae2&"
import script from "./orderGiftList.vue?vue&type=script&lang=ts&"
export * from "./orderGiftList.vue?vue&type=script&lang=ts&"
import style0 from "./orderGiftList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports